import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser, CLPUserProfile, UserDD, UserResponse } from '../../models/clpuser.model';
import { eFeatures, eUserPermissions, eUserRole } from '../../models/enum.model';
import { PCal, PCalListResponse } from '../../models/Pcal.model';
import { RoleFeaturePermissions } from '../../models/roleContainer.model';
import { PcalService } from '../../services/pcal.service';
import { GridConfigurationService } from '../../services/shared/gridConfiguration.service';
import { LocalService } from '../../services/shared/local.service';
import { UtilityService } from '../../services/shared/utility.service';
import { UserService } from '../../services/user.service';
import { Clipboard } from "@angular/cdk/clipboard"
import { ConfigDetails } from '../../models/appConfig.model';
import { AppconfigService } from '../../services/shared/appconfig.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MyCalenderService } from '../../services/my-calender.service';
import { ScheduleAppointmentRequest, ScheduleAppointmentResponse } from '../../models/scheduler.model';
import { DatePipe, formatDate } from '@angular/common';
import { GlobalService } from '../../services/global.service';
import { NotificationService } from '../../services/notification.service';
import { AppointmentSettingService } from '../../services/appointmentSetting.service';
import { CalenderDynamicRequest, CalenderSchedulerResponse, CreateScheduleRequest, CreateScheduleResponse, TimeSlotsRequest, TimeSlotsResponse } from '../../models/calender.model';
import { DropDownItem, SimpleResponse } from '../../models/genericResponse.model';
import { CountryService } from '../../services/country.service';
import { CountryCode } from 'libphonenumber-js';
import { Country, CountryListResponse } from '../../models/country.model';
import { isNullOrEmptyString } from '@progress/kendo-angular-grid/utils';
import { Subject, takeUntil } from 'rxjs';

declare var $: any;

@Component({
    selector: 'app-engage-cal',
    templateUrl: './engage-cal.component.html',
    styleUrl: './engage-cal.component.css',
    providers: [GridConfigurationService]
})
export class EngageCalComponent {


    showSpinner: boolean = false;
    roleFeaturePermissions: RoleFeaturePermissions;
    user: CLPUser;
    private encryptedUser: string = '';
    userResponse: UserResponse;
    currDate: Date = new Date();
    userList: UserDD[];
    pCalList: PCal[];
    selectedUserId: number = 0;
    public userProfile: CLPUserProfile;
    ownerTitle: string = '';
    soUrl: any;
    copyLocation: number = -1;
    dynamicSchedularMsg: string = '';
    dateFormat: string;
    selectedDate: string | Date = new Date();
    columns = [
        { field: '$', title: '', width: '40' },
        { field: 'calName', title: 'Calendar Name', width: '200' },
        { field: 'title', title: 'Title', width: '100' },
        { field: 'pCalKey', title: 'Location To Copy', width: '100' },
        { field: 'openCal', title: 'Open Calendar', width: '100' },
        { field: 'userFullName', title: 'Owner', width: '100' },
        { field: 'dtCreated', title: 'Date Created', width: '100' },
    ];
    reorderColumnName: string = 'calName,title,pCalKey,openCal,userFullName,dtCreated';
    arrColumnWidth: any[] = ['calName:200,title:100,pCalKey:100,openCal:100,userFullName:100,dtCreated:100'];
    columnWidth: string = 'calName:200,title:100,pCalKey:100,openCal:100,userFullName:100,dtCreated:100';
    scheduleAppointmentForm: FormGroup
    scheduleAppointmentWeekDay: string;
    scheduleAppointmentMonth: string;
    scheduleAppointmentDate: string;
    scheduleAppointmentYear: string;
    scheduleAppointmentTime: any;
    scheduleApptObj: CreateScheduleRequest = <CreateScheduleRequest>{};
    completeDateTime: any;
    pKey: any = '';
    cid: any = 0;
    calendarSchedulerObj: CalenderSchedulerResponse;
    aid: any = 0;
    cpu: any = 0;
    uid: any = 0;
    nm: any = '';
    ph: any = '';
    em: any = '';
    cmt: any = '';
    isApptScheduled: boolean = false;
    timeSlots: DropDownItem[];
    countryCode: string = '';
    placeHolder: string = '';
    dialCode: any = '';
    mobile_mask: string = '';
    countryList: Country[];
    countryListResponse: CountryListResponse;
    private destroy$ = new Subject<void>();

    constructor(
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _userService: UserService,
        private _pCallService: PcalService,
        public _gridCnfgService: GridConfigurationService,
        private _appConfigService: AppconfigService,
        private fb: FormBuilder,
        private myCalenderService: MyCalenderService,
        private appointmentSettingService: AppointmentSettingService,
        private _globalService: GlobalService,
        private notifyService: NotificationService,
        public _countryService: CountryService,
        private datePipe: DatePipe,
        private _clipboard: Clipboard) {
        this._localService.isMenu = true;
        this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
            if (!isNullOrUndefined(params)) {
                this.dynamicSchedularMsg = params.txt;
                this.pKey = params?.pkey;
                this.cid = params?.cid;
                this.aid = params?.aid;
                this.cpu = params?.cpu;
                this.uid = params?.uid;
                this.nm = params?.nm;
                this.ph = params?.ph;
                this.em = params?.em;
                this.cmt = params?.cmt;
            }
        })
        this._localService.isMenu = false;
        this._localService.isFooter = false;
    }

    ngOnInit(): void {
        this._appConfigService.getlandingsite()
            .then(async (result: ConfigDetails) => {
                if (result) {
                    this.soUrl = result?.configValue;
                    this.soUrl += '/calendar.aspx?pkey=';
                }
            })
        this.scheduleAppointmentForm = this.prepareScheduleAppointmentForm()
        this.setupCalendar();

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async setupCalendar() {
        this.scheduleAppointmentWeekDay = new Date(this.selectedDate).toLocaleDateString('en-us', { weekday: "long" });
        this.scheduleAppointmentMonth = new Date(this.selectedDate).toLocaleDateString('en-us', { month: "long" });
        this.scheduleAppointmentDate = new Date(this.selectedDate).toLocaleDateString('en-us', { day: "numeric" });
        this.scheduleAppointmentYear = new Date(this.selectedDate).toLocaleDateString('en-us', { year: "numeric" });
        this.selectedDate = formatDate(this.selectedDate, "MM-dd-yyyy", 'en-US');
        this.selectedUserId = this.user?.cLPUserID;
        await this.getScheduleAppointmentData();
        this.countryCode = this.userProfile?.country ? this.userProfile?.country : localStorage.getItem('sc_country') ? localStorage.getItem('sc_country') : 'US';
        await this.loadCountries();

    }


    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    this.dateFormat = this.userResponse?.user?.dateFormat;
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse?.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            this._gridCnfgService.user = this.user;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("dynamic-scheduler.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadCountries() {
        this.countryList = await this._localService.loadCountryList();
        if (this.countryList == null) {
            this._countryService.getCountryList()
                .then((response: CountryListResponse) => {
                    this.countryListResponse = UtilityService.clone(response);
                    this.countryList = UtilityService.clone(this.countryListResponse?.countries);
                    this.countryList.map(val => {
                        val.code2Lower = val?.code2.toLowerCase();
                    });

                    this.handleChangeCountry(this.countryCode, true);
                },
                    (error) => {
                        this._utilityService.handleErrorResponse(error);
                    }
                );
        }
        else {
            this.countryList.map(val => {
                val.code2Lower = val?.code2.toLowerCase();
            });

            this.handleChangeCountry(this.countryCode, true);
        }

    }

    private async handleChangeCountry(code2: string, codeType: boolean) {
        this.countryCode = code2;

        if (code2) {
            let code2Lower: string = code2.toLowerCase();
            let found: boolean = false;
            if (this.countryList) {
                this.countryList.forEach((c) => {
                    if (codeType) {
                        if (c.code2Lower == code2Lower || c.code.toLowerCase() == code2Lower) {
                            found = true;
                            let code = c?.code2;
                            this.placeHolder = c.placeholder ? this._countryService.parseSimplePhone(c.placeholder, code as CountryCode) : '';
                            this.mobile_mask = this._countryService.replaceZero(this.placeHolder);
                            this.dialCode = c.dialCode;
                        }
                    }
                    else {
                        if (c.code.toLowerCase() == code2Lower || c.code2Lower == code2Lower) {
                            found = true;
                            let code = c?.code2;
                            this.placeHolder = c.placeholder ? this._countryService.parseSimplePhone(c.placeholder, code as CountryCode) : '';
                            this.mobile_mask = this._countryService.replaceZero(this.placeHolder);
                            this.dialCode = c.dialCode;
                        }
                    }
                });

                if (!found) {
                    this.placeHolder = '001234567890';
                    this.dialCode = 1;
                    this.mobile_mask = '';
                }
            }
        }
    }

    async getLoadUsers() {
        this.showSpinner = true;
        let permission: eUserPermissions = eUserPermissions.Active;
        let includeNewUsers: boolean = false;
        if (this.user?.cLPCompanyID && this.user.cLPCompanyID > 0) {
            await this._userService.getCLPCompany_LoadUsers(this.encryptedUser, this.user?.cLPCompanyID, permission, includeNewUsers).
                then(async (result: UserDD[]) => {
                    if (!isNullOrUndefined(result))
                        this.userList = UtilityService.clone(result);
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async getPCalList(userID) {
        this.selectedUserId = userID;
        this.showSpinner = true;
        this.copyLocation = -1;
        this.getUserProfile();
        await this._pCallService.getPCalList(this.encryptedUser, this.user?.cLPCompanyID, this.selectedUserId).
            then(async (result: PCalListResponse) => {
                if (!isNullOrUndefined(result))
                    this.pCalList = UtilityService.clone(result?.pCalList);
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getUserProfile() {
        this.showSpinner = true;
        await this._userService.getUserByUserId(this.encryptedUser, this.selectedUserId)
            .then(async (result: CLPUserProfile) => {
                if (!isNullOrUndefined(result))
                    this.userProfile = UtilityService.clone(result);
                if (!isNullOrUndefined(this.userProfile))
                    this.ownerTitle = this.userProfile.firstName + this.userProfile.lastName + '\n' + this.userProfile.add1 + '\n' + this.userProfile.add2 + '\n' + this.userProfile.city + '  ' + this.userProfile.state + '  ' + this.userProfile.zip + '\n' + this.userProfile.country + '\n' + 'P:' + this.userProfile.phone + '\n' + 'F:' + this.userProfile.fax;
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    public goToLinkDynmicScheduler(dataItem, val) {
        switch (val) {
            case "userName":
                this._router.navigate(['/edit-profile', dataItem.cLPUserID]);
                break;
            case "calName":
                this._router.navigate(['calendar/pcal', dataItem.pCalID]);
                break;
            case "viewCalender":
                //this.getScheduleAppointmentData(dataItem)
                break;
            default: {
                break;
            }
        }
    }

    copyDynamicSchedulerLocationValue(val: string, rowIndex) {
        this.copyLocation = null;
        if (!isNullOrUndefined(val)) {
            this.copyLocation = rowIndex;
            this._clipboard.copy(this.soUrl + val);
        }
        else
            this.copyLocation = null;
    }

    //Schedule Appoinment Popup Methods Start

    async getScheduleAppointmentData() {
        let calenderDynamicRequest: CalenderDynamicRequest = <CalenderDynamicRequest>{};
        calenderDynamicRequest.pkey = this.pKey;
        calenderDynamicRequest.cid = this.cid;
        calenderDynamicRequest.aid = this.aid;
        calenderDynamicRequest.cpu = this.cpu;
        calenderDynamicRequest.uid = this.uid;
        calenderDynamicRequest.nm = this.nm;
        calenderDynamicRequest.ph = this.ph;
        calenderDynamicRequest.em = this.em;
        calenderDynamicRequest.cmt = this.cmt;
        if (this.pKey != "") {
            this.showSpinner = true;
            await this.myCalenderService.calenderDynamicLoad(calenderDynamicRequest)
                .then(async (result: CalenderSchedulerResponse) => {
                    if (!isNullOrUndefined(result)) {
                        this.calendarSchedulerObj = UtilityService.clone(result);
                        console.log(this.calendarSchedulerObj.AppliesToCLPUserID);
                        this.scheduleApptObj.PCalID = this.calendarSchedulerObj?.pcl?.pCalID;
                        this.scheduleApptObj.AppliesToCLPUserID = this.calendarSchedulerObj.AppliesToCLPUserID;
                        this.scheduleApptObj.ApptID = this.calendarSchedulerObj?.ApptId;
                        this.scheduleApptObj.ContactID = this.calendarSchedulerObj?.contactId;
                        this.patchScheduleApptForm();
                        if (this.calendarSchedulerObj?.pcl?.pCalID > 0) {
                            this.buildTimeSlots();
                        }
                    }
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                    this.showSpinner = false;
                });
        }
        else {
            this.notifyService.showError("Some error occured in loading calendar.", "Failed", 3000)
        }
    }

    async buildTimeSlots() {
        this.showSpinner = true;
        let timeSlotsRequest = <TimeSlotsRequest>{};
        timeSlotsRequest.appliesToCLPUserID = this.scheduleApptObj.AppliesToCLPUserID;
        timeSlotsRequest.pCalKey = this.pKey;
        timeSlotsRequest.strSelectedDate = this.datePipe.transform(new Date(this.selectedDate), 'MMddyyyy')
        await this.myCalenderService.buildTimeSlots(this.encryptedUser, timeSlotsRequest)
            .then(async (result: TimeSlotsResponse) => {
                if (!isNullOrUndefined(result)) {
                    let response = UtilityService.clone(result);
                    this.timeSlots = response?.timeSlots;
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });

    }


    async scheduleAppointment() {
        this.showSpinner = true;
        await this.myCalenderService.Schedule_Create(this.scheduleApptObj)
            .then(async (result: CreateScheduleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.isApptScheduled = true;
                    this.scheduleAppointmentForm.reset()
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }


    prepareScheduleAppointmentForm() {
        return this.fb.group({
            txtName: new FormControl('', [Validators.required]),
            txtEmail: new FormControl('', [Validators.required]),
            txtMobile: new FormControl('', [Validators.required]),
            txtNotes: new FormControl(''),
        });
    }

    onSubmitScheduleForm() {
        if (this.scheduleAppointmentForm.valid) {
            this.scheduleApptObj.Name = this.scheduleAppointmentForm.controls['txtName'].value
            this.scheduleApptObj.Email = this.scheduleAppointmentForm.controls['txtEmail'].value
            this.scheduleApptObj.Mobile = this.scheduleAppointmentForm.controls['txtMobile'].value
            this.scheduleApptObj.Notes = this.scheduleAppointmentForm.controls['txtNotes'].value
            this.scheduleAppointment()
        }
        else {
            this.notifyService.showError("Fill required fields", "Failed", 3000)
        }
    }

    onScheduleAppointmentDateChange(e) {
        this.scheduleAppointmentTime = "";
        this.scheduleAppointmentWeekDay = new Date(e).toLocaleDateString('en-us', { weekday: "long" });
        this.scheduleAppointmentMonth = new Date(e).toLocaleDateString('en-us', { month: "long" });
        this.scheduleAppointmentDate = new Date(e).toLocaleDateString('en-us', { day: "numeric" });
        this.scheduleAppointmentYear = new Date(e).toLocaleDateString('en-us', { year: "numeric" });
        this.selectedDate = formatDate(e, "MM-dd-yyyy", 'en-US');
        if (!isNullOrUndefined(e))
            this.buildTimeSlots();
    }

    onScheduleAppointmentTimeSelect(event) {
        if (event.target.value) {
            this.scheduleAppointmentTime = event.target.value
            this.completeDateTime = this.selectedDate + " " + event.target.value
            this.scheduleApptObj.DateSelected = this.completeDateTime
        }
    }

    patchScheduleApptForm() {
        this.scheduleAppointmentForm.controls['txtName'].patchValue(this.calendarSchedulerObj?.FullName);
        this.scheduleAppointmentForm.controls['txtEmail'].patchValue(this.calendarSchedulerObj?.Email);
        this.scheduleAppointmentForm.controls['txtMobile'].patchValue(this.calendarSchedulerObj?.Mobile);
        this.scheduleAppointmentForm.controls['txtNotes'].patchValue(this.calendarSchedulerObj?.Notes);
    }

    disabelSchedule() {
        if (this.scheduleAppointmentTime && this.scheduleAppointmentTime != '' && this.scheduleAppointmentTime != undefined) {
            return false;
        }
        return true;
    }
}
